import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

function ResetAlert({ email, showAlert, setShowAlert }) {
  if (!showAlert) {
    return null;
  }

  return (
    <AlertDialog defaultOpen={showAlert}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Password reset email sent</AlertDialogTitle>
          <AlertDialogDescription>
            The password reset email has been sent to the email address {email}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            className="w-full"
            onClick={() => setShowAlert(false)}
          >
            Close
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ResetAlert;
